import React from 'react';
import Sidebar from './changelog/Sidebar';
import Log from './changelog/Log';
import Footer from './shared/Footer';
import SidebarDropdown from './changelog/SidebarDropdown';

const Changelog = () => {
	return (
		<div className="page">
			<Sidebar />
			<main id="content" className="content with-sidebar">
				<div className='responsive-small'>
					<SidebarDropdown />
				</div>
				<div className="section">
					<h1>Changelog</h1>
					<Log />
				</div>
				<Footer />
			</main>
		</div>
	);
};

export default Changelog;


// WEBPACK FOOTER //
// ./src/components/Changelog.js